import { render } from "./dispositivos-logs.vue?vue&type=template&id=625c245c"
import script from "./dispositivos-logs.vue?vue&type=script&lang=js"
export * from "./dispositivos-logs.vue?vue&type=script&lang=js"

import "./dispositivos-logs.vue?vue&type=style&index=0&id=625c245c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__